import BrowserSupport from './browserSupport.js';
import BrowserInfo from './getBrowser.js';
/**
 * 判断浏览器是否可以使用mes
 * 先判断MSE属性的支持性 再判断设备类型 再判断白名单
 */
class canUseMse {
    constructor() {
        this.BrowserSupport = new BrowserSupport();
        this.BrowerInfo = new BrowserInfo();
        //console.log('------', this.BrowerInfo.get());
    }
    /**
     * @returns {Boolean} flag 是否可以用MSE的标志位
     */
    judgement() {
        let flag = false;
        let device = this.BrowerInfo.getDevice();
        if (this.BrowserSupport.ifSupportMse() && device.type == 'pc' && this.BrowerInfo.canUseBrowser()) {
            // 判断是否在白名单中
            flag = true;
        }
        return flag;
    }
}
export default canUseMse;



// WEBPACK FOOTER //
// ./components/FPlayer-component-utils/canUseMse.js